var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork2Icon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5002 43.5C26.6937 43.5 27.8383 43.0259 28.6822 42.182C29.5261 41.3381 30.0002 40.1935 30.0002 39C30.0002 37.8065 29.5261 36.6619 28.6822 35.818C27.8383 34.9741 26.6937 34.5 25.5002 34.5C26.6937 34.5 27.8383 34.0259 28.6822 33.182C29.5261 32.3381 30.0002 31.1935 30.0002 30C30.0002 28.8065 29.5261 27.6619 28.6822 26.818C27.8383 25.9741 26.6937 25.5 25.5002 25.5H19.5002V43.5H25.5002Z",
    stroke: "#06010D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 34.5H25.8742",
    stroke: "#06010D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 25.5V22.5",
    stroke: "#06010D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 46.5V43.5",
    stroke: "#06010D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5002 46.5H7.50024C6.70459 46.5 5.94153 46.1839 5.37892 45.6213C4.81631 45.0587 4.50024 44.2956 4.50024 43.5V19.5C4.50024 18.7044 4.81631 17.9413 5.37892 17.3787C5.94153 16.8161 6.70459 16.5 7.50024 16.5H40.5002C41.2959 16.5 42.059 16.8161 42.6216 17.3787C43.1842 17.9413 43.5002 18.7044 43.5002 19.5V43.5C43.5002 44.2956 43.1842 45.0587 42.6216 45.6213C42.059 46.1839 41.2959 46.5 40.5002 46.5H33.0002",
    stroke: "#06010D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5002 16.5H13.5002V12C13.5002 9.21523 14.6065 6.54451 16.5756 4.57538C18.5448 2.60625 21.2155 1.5 24.0002 1.5C26.785 1.5 29.4557 2.60625 31.4249 4.57538C33.394 6.54451 34.5002 9.21523 34.5002 12V16.5Z",
    stroke: "#06010D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork2Icon2);
export default __webpack_public_path__ + "static/media/work2-icon2.79f7de9ecbee5678a6d5faea7bdc85fb.svg";
export { ForwardRef as ReactComponent };